module.exports = __webpack_public_path__ + "img/logo.2589f3a5.svg";